import { render, staticRenderFns } from "./Piece.vue?vue&type=template&id=8b0ca0f0&scoped=true&"
import script from "./Piece.vue?vue&type=script&lang=js&"
export * from "./Piece.vue?vue&type=script&lang=js&"
import style0 from "./Piece.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Piece.vue?vue&type=style&index=1&id=8b0ca0f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0ca0f0",
  null
  
)

export default component.exports